<template lang="html">
    <div class="productos--view productos">
        <!--         <section class="vh intro">
            <div class="bkg-pieza waypoints-instant -responsiveIntron intro-quimicos" data="fadeInUp">
                <img class="w-100" src="/static/img/productos-quimicos/intro-main-quimicos.webp" :alt="$t('productos.alt_images.sellantes_lubricantes')" width="1920" height="1308" loading="lazy">
                <a href="#" v-scroll-to="'.cat-1'" class="scrolldown"></a>
                <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft -introText">
                    <div class="container-text">
                        <h1 class="title title-52">{{$t('productos.productos_quimicos.titulo-1')}}</h1>
                        <p v-html="$t('productos.productos_quimicos.texto-1')"></p>
                        <h2 class="title title-36">{{$t('productos.productos_quimicos.subtitulo')}}</h2>
                        <p v-html="$t('productos.productos_quimicos.texto-2')"></p>
                    </div>
                </div>
            </div>
        </section> -->
        <introd :product="'productos_quimicos'"></introd>
        <section class="product-cat -quimico" :data="$t(`productos.shared['ajusil']`)">
            <div class="cat-8 img-cat flex wrap justify-end align-stretch">
                <div>
                    <img class="imagen" :src="`/static/img/productos-quimicos/ajusil-${fotos.ajusil}.webp`"
                        :alt="$t('productos.alt_images.sellante_silicona')"
                        :title="$t('productos.alt_images.sellante_silicona')">
                    <button class="arrow-next" @click="fotos.ajusil++" v-if="fotos.ajusil < 2">Siguiente</button>
                    <button class="arrow-prev" @click="fotos.ajusil--" v-if="fotos.ajusil != 0">Anterior</button>
                </div>
                <div class="desc-cat flex column justify-center">
                    <h2 class="title title-36" v-html="$t('productos.ajusil.titulo')"></h2>
                    <p v-html="$t('productos.ajusil.texto')"></p>
                    <div class="pdf-info flex row justify-center">
                        <a class="btn  btn-center btn-info" @click="show_pdf(['ajusil', 'tecnica'])">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_tecnica") }}
                        </a>
                        <div class="btn-center -none"></div>
                    </div>
                    <div class="pdf-info flex row justify-center">
                        <a class="btn  btn-center btn-info" @click="show_pdf(['ajusil', 'seguridad', '200ml'])">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_seguridad") }} <small style="text-transform: lowercase;">{{ '(200 ml)' }}</small>
                        </a>
                        <a class="btn  btn-center btn-info" @click="show_pdf(['ajusil', 'seguridad', '75ml'])">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_seguridad") }} <small style="text-transform: lowercase;">{{ '(75 ml)' }}</small>
                        </a>
                    </div>
                </div>


            </div>
        </section>


        <section class="product-cat -quimico" :data="$t(`productos.shared['ajusev']`)">
            <div class="cat-7 img-cat flex wrap justify-end align-stretch">
                <div>
                    <img class="imagen" :src="`/static/img/productos-quimicos/ajusev-${fotos.ajusev}.webp`"
                        :alt="$t('productos.alt_images.sellante_silicona_electrico')"
                        :title="$t('productos.alt_images.sellante_silicona_electrico')">
                    <button class="arrow-next" @click="fotos.ajusev++" v-if="fotos.ajusev < 2">Siguiente</button>
                    <button class="arrow-prev-right" @click="fotos.ajusev--" v-if="fotos.ajusev != 0">Anterior</button>
                </div>
                <div class="desc-cat flex column justify-center">
                    <h2 class="title title-36" v-html='$t("productos.ajusev.titulo")'></h2>
                    <p v-html="$t('productos.ajusev.texto')"></p>
                    <div class="pdf-info flex row justify-center">
                        <a class="btn  btn-center btn-info" @click="show_pdf(['ajusev', 'tecnica'])">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_tecnica") }}
                        </a>
                        <a @click="show_pdf(['ajusev', 'seguridad'])" class="btn  btn-center btn-info" target="_blank">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_seguridad") }}
                        </a>
                    </div>
                </div>

            </div>
        </section>


        <section class="product-cat -quimico" :data="$t(`productos.shared['ajustick']`)">
            <div class="cat-7 img-cat flex wrap justify-end align-stretch">
                <div>
                    <img class="imagen" :src="`/static/img/productos-quimicos/ajustick-${fotos.ajustick}.webp`"
                        :alt="$t('productos.alt_images.sellante_anaerobico')"
                        :title="$t('productos.alt_images.sellante_anaerobico')">
                    <button class="arrow-next" @click="fotos.ajustick++" v-if="fotos.ajustick < 2">Siguiente</button>
                    <button class="arrow-prev" @click="fotos.ajustick--" v-if="fotos.ajustick != 0">Anterior</button>
                </div>
                <div class="desc-cat flex column justify-center">
                    <h2 class="title title-36" v-html='$t("productos.ajustick.titulo")'></h2>
                    <p v-html="$t('productos.ajustick.texto')"></p>
                    <div class="pdf-info flex row justify-center">
                        <a class="btn  btn-center btn-info" @click="show_pdf(['ajustick', 'tecnica'])">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_tecnica") }}
                        </a>
                        <a @click="show_pdf(['ajustick', 'seguridad'])" class="btn  btn-center btn-info" target="_blank">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_seguridad") }}
                        </a>
                    </div>
                </div>

            </div>
        </section>


        <section class="product-cat -quimico" :data="$t(`productos.shared['ajulock']`)">
            <div class="cat-7 img-cat flex wrap justify-end align-stretch">
                <div>
                    <img class="imagen" :src="`/static/img/productos-quimicos/ajulock-${fotos.ajulock}.webp`"
                        :alt="$t('productos.alt_images.fijador_roscas')" :title="$t('productos.alt_images.fijador_roscas')">
                    <button class="arrow-next" @click="fotos.ajulock++" v-if="fotos.ajulock < 2">Siguiente</button>
                    <button class="arrow-prev-right" @click="fotos.ajulock--" v-if="fotos.ajulock != 0">Anterior</button>
                </div>
                <div class="desc-cat flex column justify-center">
                    <h2 class="title title-36" v-html="$t('productos.ajulock.titulo')"></h2>
                    <p v-html="$t('productos.ajulock.texto')"></p>
                    <div class="pdf-info flex row justify-center">
                        <a class="btn  btn-center btn-info" @click="show_pdf(['ajulock', 'tecnica'])">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_tecnica") }}
                        </a>
                        <a @click="show_pdf(['ajulock', 'seguridad'])" class="btn  btn-center btn-info" target="_blank">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_seguridad") }}
                        </a>
                    </div>
                </div>

            </div>
        </section>

        <section class="product-cat -quimico" :data="$t(`productos.shared['ajulube']`)">
            <div class="cat-7 img-cat flex wrap justify-end align-stretch">
                <div>
                    <img class="imagen" :src="`/static/img/productos-quimicos/ajulube-${fotos.ajulube}.webp`"
                        :alt="$t('productos.alt_images.lubricante_motor')"
                        :title="$t('productos.alt_images.lubricante_motor')">
                    <button class="arrow-next" @click="fotos.ajulube++" v-if="fotos.ajulube < 2">Siguiente</button>
                    <button class="arrow-prev" @click="fotos.ajulube--" v-if="fotos.ajulube != 0">Anterior</button>
                </div>
                <div class="desc-cat flex column justify-center">
                    <h2 class="title title-36" v-html='$t("productos.ajulube.titulo")'></h2>
                    <p v-html="$t('productos.ajulube.texto')"></p>
                    <div class="pdf-info flex row justify-center">
                        <a class="btn  btn-center btn-info" @click="show_pdf(['ajulube', 'tecnica'])">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_tecnica") }}
                        </a>
                        <a @click="show_pdf(['ajulube', 'seguridad'])" class="btn  btn-center btn-info" target="_blank">
                            <span><i aria-hidden="true" class="fa fa-chevron-down"></i></span>
                            {{ $t("productos.btn_ficha_seguridad") }}
                        </a>
                    </div>
                </div>

            </div>
        </section>



        <!-- POPUP PDF SEGURIDAD -->
        <popupPdfSeguridad v-show="show_popup_pdf" :id="producto" :type="type" :show_popup_pdf.sync="show_popup_pdf" :size="size">
        </popupPdfSeguridad>

        <section class="dropdown-product-details-container">
            <dropdown v-for="(dropdown, key) in $t(`productos.productos_quimicos.details.dropdowns`)" :key="key"
                :title="dropdown.title" :contentPanel="dropdown.content"></dropdown>
            <div class="sec-center">
                <a class="btn btn-dark -yellow-full" target="_blank" :href="'mailto:' + $t(`contacto.email`)">
                    {{ $t(`productos.productos_quimicos.details.btn_more_info.text`) }}
                </a>
            </div>
        </section>

        <section class="garantia sec-center pad-sec">
            <div class="container waypoints" data="fadeInUp">
                <h2 class="title title-36" v-html="$t('productos.garantia.titulo')"></h2>
                <p>{{ $t("productos.garantia.texto") }}</p>

                <a class="btn btn-dark" target="_blank" :href="getServer + $t('enlaces.productos_certificados_calidad')">{{
                    $t("productos.garantia.boton") }}</a>
                <p>{{ $t('productos.garantia.cumplimiento') }}</p>
            </div>
        </section>

        <otras-secciones :data="['catalogo', 'area_tecnica']"></otras-secciones>
    </div>
</template>

<script lang="js">
import Dropdown from '@/components/view-parts/dropdown';
import Intro from '@/components/view-parts/intros/productos'
import Introd from '@/components/view-parts/intros/product';
import Otras_Secciones from '@/components/parts/acceso-a-secciones';
import rrssShare from '@/components/parts/rrss-share';
import popupPdfSeguridad from '@/components/view-parts/popup-pdf-seguridad';
import { mapGetters } from 'vuex';


export default {
    name: 'productos',
    props: [],
    mounted() {
        let to = this.$route.params.id;
        if ($(".product-cat -quimico[data='" + to + "']").length > 0) {
            $('body,html').animate({ scrollTop: $(".product-cat -quimico[data='" + to + "']").position().top }, 800);
        }

        document.head.querySelector("[name='keywords']").content = this.$t(`enlaces.seo.productos_quimicos.keyword`);
    },
    data() {
        return {
            show_popup: false,
            show_popup_pdf: false,
            producto: '',
            fotos: {
                'ajulock': 0,
                'ajulube': 0,
                'ajusil': 0,
                'ajustick': 0,
                'ajusev': 0,
            },
            how: '',
            img_big: '',
            type: '',
            size: ''
        }
    },
    methods: {
        show: function (value) {
            this.how = value;
            this.show_popup = true;
            this.img_big = `${value}-1`;
        },
        show_pdf: function (value) {
            this.producto = value[0];
            this.type = value[1];
            this.size = value[2];
            this.show_popup_pdf = true;
        },
        setImage: function (value) {
            this.img_big = value;
        },
        closePop: function () {
            this.show_popup = false;
            this.show_popup_pdf = false;
        },
        updateScore(newValue) {
            this.score = newValue  // 3.Updating
            console.log(newValue)
        }
    },
    computed: {
        ...mapGetters(['getServer', 'getLanguage']),
    },
    components: {
        'dropdown': Dropdown,
        'intro': Intro,
        'introd': Introd,
        'otras-secciones': Otras_Secciones,
        'rrss-share': rrssShare,
        'popupPdfSeguridad': popupPdfSeguridad
    },
    watch: {
        '$route.params.lang': function () {
            if (this.$route.params) {
                document.head.querySelector("[name='keywords']").content = this.$t(`enlaces.seo.productos_quimicos.keyword`);
            }
        }
    },
}
</script>

<style scoped>
.popup {
    display: inline-block;
}

.imagen--container {
    max-width: 100%;
    max-height: 100%;
}

.imagen--container img {
    max-width: 100%;
    max-height: 100%;
}

.btn-dark {
    margin-top: 10px;
    background: #E6007E;
    border-color: #E6007E;
    color: white;
}

.btn-center {
    margin: 10px 0;
    padding: 4px;
    font-size: 16px;
}

.btn-center.btn-info {
    max-width: 330px;
    border: 1px solid #054279;
    color: #054279;
    font-size: 12px;
    padding: 7px 0;
    font-weight: bold;
    line-height: 20px;
}

section[data="ajusil"] .btn-center.btn-info:hover {
    background: #E6007E;
    color: white;
}

.btn-center.btn-info:hover {
    background: #FFED00;
    color: #054279;
}

.btn-center.btn-info:first-child {
    margin-right: 29px;
}

.intro-quimicos {
    position: fixed !important;
}

.intro-quimicos img {
    height: 100%;
}

@media only screen and (max-width: 650px) {

    .ver.ver-responsive,
    .product-cat -quimico:nth-of-type(2n):hover .ver.ver-responsive {
        flex-direction: row-reverse;
        align-items: center;
        justify-content: space-between;
        display: flex;
    }

    .btn-light {
        color: #054279;
        border-color: #054279;
    }

    .pdf-info {
        flex-direction: column;
    }

    .btn-center.-none {
        display: none;
    }
}

@media screen and (max-width:1024px) {
    .intro-quimicos {
        position: initial !important;
    }

    .btn-center.-none {
        margin-right: 29px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/productos-quimicos.vue